import { DotOutline } from '@liveauctioneers/hammer-ui-core/icons';
import { BodySecondary, H1, H3 } from '@liveauctioneers/hammer-ui-core/text';

import { formatArticleDate } from '@/utils/dates';

import { ArticleShareButton } from './ArticleShareButton';

type Props = {
    author: string | null;
    createdAt: string | null;
    imageUrl: string | null;
    subtitle: string | null;
    title: string;
};

export const ArticlePageTitleBlock = ({ author, createdAt, imageUrl, subtitle, title }: Props) => {
    const formattedDate = formatArticleDate(createdAt);
    const hasBylineMeta = Boolean(author || formattedDate);

    return (
        <header
            className="mb-md flex w-full flex-col items-start gap-xs text-left smMin:items-center smMin:text-center"
            data-testid="article-page-title-block"
        >
            <H1>{title}</H1>
            {subtitle && <H3>{subtitle}</H3>}
            <div className="flex w-full flex-col items-start gap-xs smMin:flex-row smMin:flex-wrap smMin:items-center smMin:justify-center">
                {hasBylineMeta && (
                    <>
                        <div className="flex flex-wrap items-center gap-xs">
                            {author && <BodySecondary color="secondary">By {author}</BodySecondary>}
                            {author && formattedDate && (
                                <BodySecondary
                                    aria-hidden="true"
                                    color="secondary"
                                >
                                    <DotOutline
                                        size="xs"
                                        style="fill"
                                    />
                                </BodySecondary>
                            )}
                            {formattedDate && <BodySecondary color="secondary">{formattedDate}</BodySecondary>}
                        </div>
                        <BodySecondary
                            aria-hidden="true"
                            className="hidden smMin:inline"
                            color="secondary"
                        >
                            <DotOutline
                                size="xs"
                                style="fill"
                            />
                        </BodySecondary>
                    </>
                )}
                <ArticleShareButton
                    imageUrl={imageUrl}
                    title={title}
                />
            </div>
        </header>
    );
};
